import React, { useCallback } from 'react'
import styled from 'styled-components'
import Typography from '@mui/material/Typography'
import { Avatar } from '@mui/material'
import AutocompleteChip from '../components/AutocompleteChip';
import AutocompleteInput from '../components/AutocompleteInput';

const Container = styled.div`
  display: flex;
  padding: 10px;
`

const AssetPhoto = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 10px;
`

const AssetData = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

const ProgressBar = styled.div`
  background: #1565c0;
  transition: width .5s;
  display: flex;
  justify-content: center;
  height: 18px;
  border-radius: 5px;
  width: ${p => p.percent}%;
`

const Photo = styled(Avatar)`
  width: 100px;
  height: 100px;
  background: #ccc;
  img {
    object-fit: contain;
  }
`

const MetaLink = styled.a`
  text-decoration: underline;
  cursor: pointer;
  margin-top: 8px;
  
  &:hover {
    filter: brightness(1.5);
  }
`

const assetDataTitleStyle = { fontWeight: 'bold' }
const progressLabelStyle = { color: '#fff' }

const AssetCard = ({ asset, tags, types, onSave, onConfigOpen, onTypeChange, onTagsChange }) => {
  const handleSave = useCallback(() => {
    onSave(asset.tags, asset.type, null, asset?.asset_id)
  }, [asset?.asset_id, asset.tags, asset.type, onSave])

  const handleOpenMetadata = useCallback(() => {
    onConfigOpen(asset)
  }, [asset, onConfigOpen])

  const handleTypeChange = useCallback((currentType) => {
    onTypeChange(asset.asset_id, currentType)
  }, [asset.asset_id, onTypeChange])

  const handleTagsChange = useCallback((currentTags) => {
    onTagsChange(asset.asset_id, currentTags)
  }, [asset.asset_id, onTagsChange])

  return (
    <Container>
      <AssetPhoto>
        <Photo
          variant="square"
          src={asset.url}
          alt={asset.asset_id}
        />
        <MetaLink onClick={handleOpenMetadata}>Metadata</MetaLink>
        <MetaLink onClick={handleSave}>Save</MetaLink>
      </AssetPhoto>
      <AssetData>
        <Typography sx={assetDataTitleStyle}>{asset.asset_id}</Typography>
        <ProgressBar percent={asset?.percent}>
          <Typography variant="caption" sx={progressLabelStyle}>{`${asset?.percent}%`}</Typography>
        </ProgressBar>
        <AutocompleteChip label='Tags' options={tags} value={asset.tags} onChange={handleTagsChange} placeholder='Select the asset tags' />
        <AutocompleteInput label='Types' options={types} value={asset.type} onChange={handleTypeChange} placeholder='Write the asset type' />
      </AssetData>
    </Container>
  )
}

export default AssetCard
